import * as MaterialUI from '@mui/material';

export const List = MaterialUI.styled(MaterialUI.List)<{
}>(({ theme }) => ({
  borderLeftColor: theme.palette.primary.main,
  borderLeftStyle: 'solid',
  borderLeftWidth: '4px'
}));

export const ListItem = MaterialUI.styled(MaterialUI.ListItem)<{}>(({theme}) => ({
  paddingBottom: '6px',
  paddingTop: '6px',
  marginTop: 0,
  "&:first-of-type": {
    paddingTop: 0,
  },
  "&:last-of-type": {
    paddingBottom: 0
  }
}));

export const Link = MaterialUI.styled(MaterialUI.Link)<{
}>(({ theme }) => ({
  cursor: "pointer",
}));